import { addQueryArgs } from '@wordpress/url';
import { getParamsOfUrl, getUrl } from '../mixins/search';

const agentListNode = document.querySelector( '.realpress-agent-list' );
let sortNode, containerNode, searchNode, restNamespace, orderby, order, query, agentListContent;
const init = () => {
	sortNode = agentListNode.querySelector( '.realpress-sort-by select' );
	agentListContent = agentListNode.querySelector( '.realpress-agent-list-content' );
	containerNode = agentListNode.querySelector( '.realpress-agent-list-container' );
	searchNode = document.querySelector( '.realpress-agent-search' );

	restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
	query = { offset: 1, orderby: 'display_name', order: 'ASC' };
	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}
};

const realpressAgentList = () => {
	if ( ! agentListNode ) {
		return;
	}
	init();
	getAgents( query );
	sort();
	search();
};

const getAgents = ( query = {} ) => {
	containerNode.style.opacity = 0.4;
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/agents', query ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			containerNode.innerHTML = res.data.content;
		} else if ( res.msg ) {
			containerNode.innerHTML = res.msg;
		}
		if ( res.data.pagination !== undefined ) {
			agentListNode.querySelector( '.realpress-agent-list-pagination' ).innerHTML = res.data.pagination;
		} else {
			agentListNode.querySelector( '.realpress-agent-list-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			agentListNode.querySelector( '.realpress-agent-list-from-to' ).innerHTML = res.data.from_to;
		} else {
			agentListNode.querySelector( '.realpress-agent-list-from-to' ).innerHTML = '';
		}

		const paginationNode = agentListNode.querySelector( '.realpress-pagination' );
		if ( !! paginationNode ) {
			const pageNodes = paginationNode.querySelectorAll( 'a' );
			for ( let i = 0; i < pageNodes.length; i++ ) {
				pageNodes[ i ].addEventListener( 'click', function( event ) {
					event.preventDefault();
					const offset = this.getAttribute( 'data-page' );
					getAgents( { ...query, offset } );
					agentListContent.scrollIntoView( { behavior: 'smooth' } );
				} );
			}
		}
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		const urlPush = getUrl( query );
		window.history.pushState( '', '', urlPush );
		containerNode.style.opacity = 1;
	} );
};

const sort = () => {
	sortNode.addEventListener( 'change', function( event ) {
		const selected = event.target.value;
		switch ( selected ) {
		case 'name_asc':
			orderby = 'display_name';
			order = 'ASC';
			break;
		case 'name_desc':
			orderby = 'display_name';
			order = 'DESC';
			break;
		default:
			orderby = 'ID';
			order = 'DESC';
			break;
		}

		getAgents( { ...query, orderby, order } );
		agentListContent.scrollIntoView( { behavior: 'smooth' } );
	} );
};

const search = () => {
	if ( ! searchNode ) {
		return;
	}
	const searchButton = searchNode.querySelector( 'button' );
	searchButton.addEventListener( 'click', function() {
		const fieldNodes = searchNode.querySelectorAll( 'input,select' );
		if ( ! fieldNodes ) {
			return;
		}
		for ( let i = 0; i < fieldNodes.length; i++ ) {
			const fieldNode = fieldNodes[ i ];
			const name = fieldNode.getAttribute( 'name' );

			if ( fieldNode.value === '' ) {
				if ( query.hasOwnProperty( name ) ) {
					delete query[ name ];
				}
			} else {
				query[ name ] = fieldNode.value;
			}
		}
		query = { ...query, offset: 1 };

		getAgents( query );
		agentListContent.scrollIntoView( { behavior: 'smooth' } );
	} );
};

export default realpressAgentList;
